import { AccountOpeningReason } from '@Pages/happyFlowPages/accountOpeningReason/accountOpeningReason';
import { planSelectionQueryParamsSchema } from '@Pages/happyFlowPages/planSelection/queryParamsSchema';
import { beforeLoadGeneral } from '@Router/middleware';
import { routesModel } from '@Router/router.consts';
import { RoutesMap } from '@Router/router.types';
import { dataLayerHandler } from '@Services/analytics/analytics.service';
import { GTMEventLabel } from '@Services/analytics/types';
import { getDeviceId } from '@Services/device-id/getDeviceId';
import { useBoundStore } from '@Store/useBoundStore';
import { createRoute, Route } from '@tanstack/react-router';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';
import { Suspense } from 'react';
import { PlanSelectionPage, ReviewPage, SuccessPage } from '..';
import { GeneralSpinner } from '@Components/generalSpinner';
import { rootRoute } from './rootRoute';

const planSelectionRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.PLAN_SELECTION].path,
  beforeLoad: () => {
    beforeLoadGeneral({ page: RoutesMap.PLAN_SELECTION, shouldUpdateServerNavStack: true });
  },
  component: () => (
    <Suspense fallback={<GeneralSpinner />}>
      <PlanSelectionPage />
    </Suspense>
  ),
  validateSearch: zodSearchValidator(planSelectionQueryParamsSchema),
});

const ReviewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.REVIEW].path,
  beforeLoad: () => {
    beforeLoadGeneral({ page: RoutesMap.REVIEW, shouldUpdateServerNavStack: false });
    dataLayerHandler(GTMEventLabel.CONFIRM_SCREEN);
    getDeviceId().then((deviceId) =>
      useBoundStore.getState().onboardingSlice.setDeviceId(deviceId)
    );
  },
  component: () => (
    <Suspense fallback={<GeneralSpinner />}>
      <ReviewPage />
    </Suspense>
  ),
});

const SuccessRoute = new Route({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.SUCCESS].path,
  beforeLoad: () => {
    beforeLoadGeneral({ page: RoutesMap.SUCCESS, shouldUpdateServerNavStack: false });
  },
  component: () => (
    <Suspense fallback={<GeneralSpinner />}>
      <SuccessPage />
    </Suspense>
  ),
});

const AccountOpeningReasonRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.ACCOUNT_OPENING_REASON].path,
  beforeLoad: () => {
    beforeLoadGeneral({
      page: RoutesMap.ACCOUNT_OPENING_REASON,
      shouldUpdateServerNavStack: false,
    });
  },
  component: () => (
    <Suspense fallback={<GeneralSpinner />}>
      <AccountOpeningReason />
    </Suspense>
  ),
});

export const finishingRoutes = [
  AccountOpeningReasonRoute,
  planSelectionRoute,
  ReviewRoute,
  SuccessRoute,
];
